import type { RedemptionConfiguration } from '../../survey-tool/declarations/ah-api';
import type { RedemptionAction } from '../actions/redemption-actions';

import * as types from '../actions/action-types';

type RedemptionReducerState = RedemptionConfiguration[] | null;

export default function redemptionReducer(
  state: RedemptionReducerState = null,
  action: RedemptionAction
): RedemptionReducerState {
  switch (action.type) {
    case types.LOAD_REDEMPTIONS_SUCCESS:
      return action.redemptions;
    default:
      return state;
  }
}
